// api/axios.js
import axios from 'axios';
import Vue from 'vue';
import router from '@/router';
const instance = axios.create({
	baseURL: 'https://api.boyueda.vip', // 后端 API 地址
	timeout: 50000, // 请求超时时间
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded', // 默认设置为 JSON 格式
	},
});

// 添加请求拦截器
instance.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token'); // 假设从 localStorage 获取 token
		if (token) {
			config.headers.token = `${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// 添加响应拦截器
instance.interceptors.response.use(
	(response) => {
		return response.data; // 直接返回数据
	},
	(error) => {
		// 对响应错误做点什么
		if (error.response) {
			// 根据状态码进行错误处理
			switch (error.response.status) {
				case 401:
					// 如果是未授权错误（可能是token失效）
					// 
					// 清除可能存在的用户信息
					localStorage.removeItem('token');
					Vue.prototype.$message({
						type: 'err',
						message: '未登录或登录状态已过期，请重新登录'
					});
					setTimeout(() => {
						router.push('/login'); // 推荐方式
					}, 2000)

					break;
				case 403:
					// 没有权限访问资源
					console.error("没有权限访问该资源");
					break;
				case 404:
					// 找不到请求的资源
					console.error("请求的资源不存在");
					break;
				default:
					console.error(error.response.data.message);
			}
		}
		return Promise.reject(error);
	}
);

export default instance;